var $ = require('jquery');
var Isotope = require('isotope-layout');
var Packery = require('isotope-packery');
var LightGallery = require('lightgallery');
var LightGalleryFullScreen = require('lg-fullscreen.js');
var LightGalleryZoom = require('lg-zoom.js');


// element argument can be a selector string
//   for an individual element
$(function () {
    $('.image-gallery').each(function () {
        const iso = new Isotope(this, {
            itemSelector: '.gallery-item',
            layoutMode: 'packery',
            percentPosition: true,
            transitionDuration: 0,
            packery: {
                horizontalOrder: false,
                gutter: 0
            }
        });
        $(this).find('img').on('load', function() {
            iso.layout();
        });

        lightGallery(this, {
            selector: '.gallery-item a',
            fullScreen: true
        });
    });
});

